// BHP-1132: create a generic VPS.
//
// `POST /api/vps` (BHP-1130) provisions a real server at Hetzner and returns the
// row read back from it, so the response is already the new truth. Only the
// collection behind the overviews holds a copy, so that is what we invalidate —
// there is no detail page or live-state cache for a server that did not exist a
// moment ago. Prefix key `['hydra','vps','collection']` matches every page.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { httpClient } from '../../../shared/http/httpClient';
import type { VpsSummary } from '../domain/vpsSummary';
import type { VpsCreateInput } from '../domain/vpsCreate';

export function useVpsCreate(): {
  save: (input: VpsCreateInput) => Promise<VpsSummary>;
  isPending: boolean;
  error: unknown;
  reset: () => void;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (input: VpsCreateInput) =>
      httpClient.post<VpsSummary>('/vps', input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['hydra', 'vps', 'collection']
      });
    }
  });

  return {
    save: (input: VpsCreateInput) => mutation.mutateAsync(input),
    isPending: mutation.isPending,
    error: mutation.error,
    reset: () => {
      mutation.reset();
    }
  };
}
